import {
  RememberMeRow,
  RememberMeLabel,
  RememberMeForgotPasswordWrapper,
  ForgotPasswordLabel,
  EyeWrapper,
  PasswordInputWrapper,
  ButtonContainer,
  EmailInputWrapper,
  Form,
} from './LoginPage.styled';
import { useState } from 'react';
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch';
import Input from 'components/Input/Input';
import Button from 'components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthWrapper from '../AuthWrapper/AuthWrapper';
import { RoutesConfig } from 'navigation/routes';
import { usePageTitle } from 'utils/hooks/usePageTitle';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Eye, EyeSlash } from '@phosphor-icons/react';
import Icon from 'components/Icon/Icon';
import { COLORS } from 'assets/styled';
import { useLogin } from './hooks';
import { useHandleLoginSuccess } from 'utils/hooks/useHandleLoginSuccess';

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [hidePassword, setHidePassword] = useState<boolean>(true);
  const [rememberMe, setRememberMe] = useState<boolean>(true);
  const { isPhone } = useBreakpointFlag();

  usePageTitle('Login');

  const handleEyeClick = () => {
    setHidePassword(!hidePassword);
  };

  const handleCheckboxClick = () => {
    if (!isLoading) {
      setRememberMe(!rememberMe);
    }
  };

  const { data: loginData, mutate: login, isLoading } = useLogin();

  useHandleLoginSuccess(loginData);

  const handleEnterKeyPress = (event: any) => {
    if (event.key === 'Enter') {
      login({ email, password });
    }
  };

  return (
    <AuthWrapper title={t('Log in')}>
      <Form>
        <EmailInputWrapper>
          <Input
            height={'55rem'}
            placeholder={t('E-mail')}
            value={email}
            onChange={(e: any) => setEmail(e.target.value)}
            wrapperStyles={{ width: '100%' }}
            width={'100%'}
            autoComplete="email"
          />
        </EmailInputWrapper>
        <PasswordInputWrapper>
          <Input
            height={'55rem'}
            placeholder={t('Password')}
            type={hidePassword ? 'password' : ''}
            value={password}
            onChange={(e: any) => setPassword(e.target.value)}
            wrapperStyles={{ width: '100%' }}
            width={'100%'}
            onKeyDown={handleEnterKeyPress}
            autoComplete="current-password"
          />
          <EyeWrapper onClick={() => handleEyeClick()}>
            <Icon
              svg={hidePassword ? Eye : EyeSlash}
              color={COLORS.BLACK}
              size={20}
            />
          </EyeWrapper>
        </PasswordInputWrapper>
        <RememberMeForgotPasswordWrapper>
          <RememberMeRow>
            <ToggleSwitch
              isChecked={rememberMe}
              onClick={() => handleCheckboxClick()}
            />
            <RememberMeLabel onClick={() => handleCheckboxClick()}>
              {t('Remember me')}
            </RememberMeLabel>
          </RememberMeRow>
          <ForgotPasswordLabel
            onClick={() =>
              navigate(RoutesConfig.RequestPasswordResetPage.fullPath)
            }
          >
            {t('Forgot your password?')}
          </ForgotPasswordLabel>
        </RememberMeForgotPasswordWrapper>
        <ButtonContainer>
          <Button
            label={t('Continue')}
            primary
            disabled={isLoading}
            width={isPhone ? '100%' : '580rem'}
            height={'55rem'}
            onClick={() => login({ email, password })}
          />
        </ButtonContainer>
      </Form>
    </AuthWrapper>
  );
};

export default LoginPage;
